import React from 'react';
import classnames from 'classnames';

import config from '../config';
import { is768Query } from '~/core/scripts/mediaquery-helper';
import { translate } from '~/core/scripts/chart-components/utils';

export default ({ xScale, yScale, series }) => {
  const isSmallScreen = !is768Query();

  const labels = Object.keys(config)
    .filter(key => key !== 'INSGESAMT')
    .filter(
      key =>
        !isSmallScreen || (isSmallScreen && (typeof config[key].labelMobile === 'undefined' || config[key].labelMobile))
    )
    .map(key => {
      const currConfig = config[key];
      const data = series
        .find(seg => seg.key === key)
        .find(s => s.data.year.toString() === currConfig.labelXPos.toString());

      const xOffset = currConfig.xOffset ? currConfig.xOffset(xScale) : 0;

      return {
        key,
        text: currConfig.label,
        x: xScale(currConfig.labelXPos) + xScale.bandwidth() * 0.5 + xOffset,
        y: yScale(data[1] - (data[1] - data[0]) * 0.5),
        fontSize: isSmallScreen ? currConfig.labelFontSizeMobile : currConfig.labelFontSize,
        color: currConfig.colorDark,
        showIcon: currConfig.showIcon,
        textAnchor: currConfig.textAnchor || 'start'
      };
    });

  const iconSize = isSmallScreen ? 25 : 50;

  return (
    <g className="bumpchart__labels">
      {labels.map(label => (
        <g
          className={classnames('bumpchart__label', label.key.toLowerCase(), {
            'has-icon': label.showIcon
          })}
          transform={translate(label.x, label.y)}
          key={`label_${label.key}`}
          textAnchor={label.textAnchor}
        >
          {label.showIcon && (
            <svg
              x={label.textAnchor === 'start' ? 0 : -iconSize}
              y={-(iconSize + 5)}
              height={iconSize}
              width={iconSize}
              className="icon car-icon"
              color={label.color}
            >
              <use xlinkHref={`spritemap.svg#icon-car_${label.key.toLowerCase()}`} />
            </svg>
          )}
          <text x={0} dy={0} className="bumpchart__label-text" fontSize={label.fontSize} fill={label.color}>
            {label.text}
          </text>
        </g>
      ))}
    </g>
  );
};
